export default class LocatorSwitch {
  constructor() {
    const _ = this;

    _.$switch = document.querySelector('.js-locator-switch');
    _.$anchors = _.$switch.querySelectorAll('.js-locator-switch-anchor');
    _.$currentActive = null;

    _.handleIntersection = _.handleIntersection.bind(_);

    _.observer = new IntersectionObserver(_.handleIntersection, { rootMargin: '-33% 0px -33% 0px' });
  }

  init() {
    const _ = this;

    for (let i = 0; i < _.$anchors.length; i++) {
      const $target = document.querySelector(_.$anchors[i].getAttribute('href'));
      _.observer.observe($target);
    }
  }

  handleIntersection(entries) {
    const _ = this;

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (_.$currentActive !== null) {
          _.$currentActive.classList.remove('is-active');
        }

        _.$currentActive = document.querySelector(`.js-locator-switch-anchor[href="#${entry.target.id}"]`);
        _.$currentActive.classList.add('is-active');
      }
    });
  }
}
